// La page Signaux, français. Le vocabulaire partagé des signaux vit dans SignalsZone.fr.ts.
import { registerFr } from '../i18n/index.js';

registerFr({
  'monitors': 'veilles',
  'runs in 24h': 'passages en 24 h',
  'suggested actions are proposals': 'les actions suggérées sont des propositions',
  'New monitor': 'Nouvelle veille',
  'Presets': 'Modèles',
  'All signals': 'Tous les signaux',
  'People': 'Personnes',
  'Organisations': 'Organisations',
  'Filter signals…': 'Filtrer les signaux…',

  // le rail
  'nothing waiting': 'rien en attente',
  'Last 7d': '7 derniers jours',
  'acted on': 'traités',
  'no summary could be read': 'aucun résumé lisible',
  'Monitors': 'Veilles',
  'no target is watched yet': 'aucune cible surveillée',
  'Scout': 'Éclaireur',
  'queued': 'en file',
  'no worker': 'aucun ouvrier',
  'last claim {when}': 'dernier retrait {when}',
  'never claimed a job': 'n’a jamais pris de tâche',
  'refused in 24h': 'refusés en 24 h',
  'the scout service has not answered': 'le service éclaireur n’a pas répondu',
  'LinkedIn posts': 'Publications LinkedIn',
  'manual import only · LinkedIn is never fetched': 'import manuel seulement · LinkedIn n’est jamais interrogé',

  // nouveaux signaux
  'New signals': 'Nouveaux signaux',
  'the quote is what the monitor read, character for character': 'la citation est ce que la veille a lu, caractère par caractère',
  'When': 'Quand',
  'Kind': 'Type',
  'Concerns': 'Concerne',
  'Signal · source · suggested action': 'Signal · source · action suggérée',
  'computed from what the record already holds': 'calculé à partir de ce que le dossier contient déjà',
  'Draft mail': 'Rédiger un courriel',
  'Draft {ref} filed for review': 'Brouillon {ref} déposé pour revue',
  'Nothing waiting': 'Rien en attente',
  'No signal matches this filter.': 'Aucun signal ne correspond à ce filtre.',
  'No signal is waiting for a decision. Monitors run on their cadence; add one below, or enable a preset.':
    'Aucun signal n’attend de décision. Les veilles tournent à leur cadence ; ajoutez-en une ci-dessous, ou activez un modèle.',

  // veilles
  'a refusal is recorded, never a silent skip': 'un refus est consigné, jamais passé sous silence',
  'Add monitor': 'Ajouter une veille',
  'Target': 'Cible',
  'Target — a URL, a UID or a query': 'Cible — une URL, un IDE ou une requête',
  'Cadence': 'Cadence',
  'Cadence · hours': 'Cadence · heures',
  'h': 'h',
  'Last run': 'Dernier passage',
  'Outcome': 'Issue',
  'never run': 'jamais passée',
  'Run now': 'Lancer',
  'Running…': 'En cours…',
  'Pause': 'Suspendre',
  'Resume': 'Reprendre',
  'Monitor added': 'Veille ajoutée',
  'Could not add the monitor.': 'Impossible d’ajouter la veille.',
  '{target}: {outcome}': '{target} : {outcome}',
  '{target}: run started': '{target} : passage lancé',
  '{target}: still running — the outcome lands in the Monitors table.':
    '{target} : toujours en cours — le résultat apparaîtra dans le tableau des monitores.',
  'done': 'terminé',
  'The run failed.': 'Le passage a échoué.',
  'The monitors could not be read.': 'Les veilles n’ont pas pu être lues.',
  'No monitor is configured. Add one above, or enable a preset — they ship disabled, because a monitor nobody asked for is egress nobody authorised.':
    'Aucune veille n’est configurée. Ajoutez-en une ci-dessus, ou activez un modèle — ils sont livrés désactivés, car une veille que personne n’a demandée est un trafic sortant que personne n’a autorisé.',
  'Website, careers, tender and budget targets are fetched by the scout, which respects robots.txt and never logs in. SHAB and Zefix are read from their own APIs. LinkedIn is never fetched.':
    'Les cibles site, emplois, appels d’offres et budget sont récupérées par l’éclaireur, qui respecte robots.txt et ne se connecte jamais. La FOSC et Zefix sont lues via leurs propres API. LinkedIn n’est jamais interrogé.',

  // modèles
  'one click each · they ship disabled': 'un clic chacun · livrés désactivés',
  'Enable': 'Activer',
  'enabled': 'activé',
  'No preset is shipped.': 'Aucun modèle n’est livré.',

  // traités
  'Acted on · 7d': 'Traités · 7 j',
  'Nothing was acted on this week.': 'Rien n’a été traité cette semaine.',
  'This could not be read.': 'Ceci n’a pas pu être lu.',
}, 'SignalsPage');
